import { render, staticRenderFns } from "./OrderConfirmModal.vue?vue&type=template&id=10858c16&scoped=true"
import script from "./OrderConfirmModal.vue?vue&type=script&lang=js"
export * from "./OrderConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10858c16",
  null
  
)

export default component.exports